import { Component, OnInit } from '@angular/core';
import { PlatformStats, CompanySummary, SuperAdminService } from '../services.service';

@Component({
  selector: 'app-superadmin-dashboard',
  templateUrl: './superadmin-dashboard.component.html',
  styleUrls: ['./superadmin-dashboard.component.css']
})
export class SuperadminDashboardComponent implements OnInit {

  stats?: PlatformStats;
  companies: CompanySummary[] = [];
  loading = true;
  today   = new Date();

  constructor(private superAdminService: SuperAdminService) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;

    // Load stats
    this.superAdminService.getStats().subscribe({
      next: stats => {
        this.stats   = stats;
        this.loading = false;
      },
      error: () => { this.loading = false; }
    });

    // Load companies
    this.superAdminService.getCompanies().subscribe({
      next: companies => this.companies = companies
    });
  }

  // ── Computed ──────────────────────────────────────────────

  get recentCompanies(): CompanySummary[] {
    return [...this.companies]
      .sort((a, b) => new Date(b.createdUtc).getTime() - new Date(a.createdUtc).getTime())
      .slice(0, 8);
  }

  get avgWorkersPerCompany(): string {
    if (!this.stats || !this.stats.totalCompanies) return '0';
    return (this.stats.totalWorkers / this.stats.totalCompanies).toFixed(1);
  }

  get avgJobsPerCompany(): string {
    if (!this.stats || !this.stats.totalCompanies) return '0';
    return (this.stats.totalJobs / this.stats.totalCompanies).toFixed(1);
  }

  get avgLogsPerCompany(): string {
    if (!this.stats || !this.stats.totalCompanies) return '0';
    return (this.stats.totalLogs / this.stats.totalCompanies).toFixed(1);
  }
}